import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class ListSharingGuard implements CanActivate {
    public validationDate: boolean = false;

    private readonly isValidationDateSource: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public isValidationDate$: Observable<boolean> = this.isValidationDateSource.asObservable();

    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.validationDate) {
            return this.validationDate;
        }
        this.router.navigate(["/ma-liste/contrat"]);
        return this.validationDate;
    }

    public toggleValidationdate(val: boolean) {
        this.validationDate = val;
        this.isValidationDateSource.next(val);
    }
}
